import * as React from 'react';
import { cn } from '@/lib/utils';

/** Base class shared by MenuPanel and all Radix dropdown/sub-content containers. */
export const MENU_PANEL_BASE =
  'border-neutral-border bg-neutral-white rounded-md border py-[18px] px-[16px] flex flex-col gap-3 text-black';

interface MenuPanelProps extends React.HTMLAttributes<HTMLDivElement> {}

/**
 * Reusable container that applies the standard menu/dropdown panel styles:
 * - py-[18px] px-[16px] padding
 * - 12px gap between items (gap-3)
 * - neutral border + white background
 *
 * Use this wherever you need a menu-style panel outside of Radix dropdowns.
 * Radix DropdownMenuContent / DropdownMenuSubContent also consume MENU_PANEL_BASE.
 */
export function MenuPanel({ className, children, ...props }: MenuPanelProps) {
  return (
    <div className={cn(MENU_PANEL_BASE, className)} {...props}>
      {children}
    </div>
  );
}
